export default "__VITE_ASSET__Cnb6jYU3__"